import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import KeyboardArrowUp from '@mui/icons-material/KeyboardArrowUp';

import { registerDecoration } from 'core/forms';

import { createIconComponent } from 'uikit/icons';
import { Button } from 'uikit/buttons';
import { Typo } from 'uikit/content';

import InfoBox from '../../exceed/components/infoBox';

import styles from '../styles/formDecorationCollapseInfo.module.scss';

const FormDecorationCollapseInfo = ({ schema: { alwaysShownContent, hiddenContent } }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={styles.element}>
      <InfoBox className={styles.infoBox}>
        <div className={styles.alwaysShown}>
          {createIconComponent({ icon: alwaysShownContent.icon, className: styles.icon, size: 24 })}
          <div className={styles.alwaysShownContent}>
            <Typo element="p" variant="s03" weight="medium" className={styles.title}>
              {alwaysShownContent.title}
            </Typo>
            <Typo element="span" color="secondary" variant="s02">
              {alwaysShownContent.body}
            </Typo>
          </div>
          <Button
            variant="ghost"
            size="xsmall"
            icon={<KeyboardArrowUp sx={{ height: 18, width: 18 }} />}
            className={classnames(styles.icon, { [styles.isOpen]: isOpen })}
            onClick={() => setIsOpen(!isOpen)}
          />
        </div>
        {isOpen && (
          <>
            <div className={styles.divider} />
            <div className={styles.hidden}>
              <Typo element="p" variant="s02" weight="medium" className={styles.title}>
                {hiddenContent.title}
              </Typo>
              <a href={hiddenContent.link} target="_blank" className={styles.url} rel="noreferrer">
                <Typo element="span" variant="b01" className={styles.name}>
                  {hiddenContent.linkText}
                </Typo>
              </a>
            </div>
          </>
        )}
      </InfoBox>
    </div>
  );
};

FormDecorationCollapseInfo.propTypes = {
  schema: PropTypes.shape({
    alwaysShownContent: PropTypes.shape({
      icon: PropTypes.string,
      title: PropTypes.string,
      body: PropTypes.string,
    }).isRequired,
    hiddenContent: PropTypes.shape({
      title: PropTypes.string,
      link: PropTypes.string,
      linkText: PropTypes.string,
    }).isRequired,
  }).isRequired,
};

registerDecoration('CollapseInfo', React.memo(FormDecorationCollapseInfo));

export default FormDecorationCollapseInfo;
